import { LineItem, PrintType, ProductType } from "@/types/types"
import { currency } from "./getCurrency"
import { 
  printTypeToShopifyVariantName,
  productTypeToShopifyProductName,
  productTypeToShopifyProductTitle
} from "../types/ga4Tracking"

declare global {
  interface Window {
    pintrk?: Function // Pinterest
    pintrkMulti?: Function // Custom Pinterest Logic to track multiple pixels
    fbq?: Function // Facebook
    ttq: {
      track: Function // Tiktok
    }
    dataLayer: any[] // Google Tag Manager
  }
}

export default function fireAddToCartEvent(addedItem: LineItem) {
  const productType = addedItem.product.type
  const price = addedItem.price
  const productId = addedItem.product.productId
  const printType = addedItem.print.type
  const productName = productType + "_" + productId
  const variant = printTypeToShopifyVariantName[printType]
  const item_id = productTypeToShopifyProductTitle[productType]
  const item_name = productTypeToShopifyProductName[productType]

  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: productName,
      contents: [addedItem],
      content_category: printType,
      content_ids: [productId],
      content_type: productType,
      value: price,
      currency: 'EUR'
    });
  }
  if (window.ttq) {
    window.ttq.track('AddToCart',{
      content_id: productName,
      content_name: productName,
      quantity: 1,
      content_type: 'product',
      value: price,
      price, // has different fields for value and price -> Not sure why?
      currency: 'EUR'
    })
  }

  if (window.pintrkMulti) {
    window.pintrkMulti('track', 'AddToCart', {
      property: productType
    });

  } else {
    if (window.pintrk) {
      window.pintrk('track', 'AddToCart', {
        property: productType
      })
    }
  }
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        value: price,
        currency: currency,
        items: [
          {
            item_id: item_id,
            item_name: item_name,
            item_variant: variant,
            item_brand: "Heureka Prints",
            price: price,
            quantity: 1,
          },
        ],
      },
    });
  }
}